<template>
  <transition name="fade" appear>
    <div class="dimmed" @click="closeDimmed">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    closeToClick: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    let body = document.querySelector('body')
    body.style.overflow = 'hidden'
  },
  destroyed () {
    let body = document.querySelector('body')
    body.style.overflow = 'initial'
  },
  methods: {
    closeDimmed (e) {
      if (this.closeToClick && e.target.className.match('dimmed')) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.dimmed {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000001;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.6);
  transition: opacity 0.3s ease;

  & > /deep/ * {
    @include positionXYcenter;
  }

  &.fade-enter-active,
  &.fade-leave-active {
    opacity: 1;
    transition: opacity 0.15s ease;
  }
  &.fade-enter,
  &.fade-leave-to{
    opacity: 0;
  }
}
</style>
